import { css } from "styled-components";
import token from "styled-token";
/** @class PropertyCardPhotoWrapperMixin */

/** @method */

export var PropertyCardPhotoWrapperMixin = function PropertyCardPhotoWrapperMixin() {
  return token("radii.md", function (borderRadius) {
    return css(["display:grid;grid-area:photo;grid-template-areas:\"photo-top\" \"photo-center\" \"photo-bottom\";grid-template-rows:auto 1fr auto;border-radius:", "px;"], borderRadius);
  });
};